import { Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import CustomerDashboard from "../components/Customer/CustomerDashboard";
import HomeComponent from "../components/home/HomeComponent";
import SupportDashboard from "../components/Support/SupportDashboard";
import Login from "../components/Login/Login";
import AccountsComponent from "../components/accounts/accountsComponent";
import PlayerWallComponent from "../components/home/PlayerWallComponent";

const ProtectedRoute = ({ children, allowedRoles }) => {
  const { user } = useAuth();

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles && !allowedRoles.includes(user.role.name)) {
    if (user.role.name === "customer") {
      return <Navigate to="/dashboard/customer/Home" replace />;
    } else if (user.role.name === "support" || user.role.name === "operator") {
      return <Navigate to="/support" replace />;
    }
  }

  return children;
};

function LoadingScreen() {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <div>در حال بارگذاری...</div>
    </div>
  );
}

function AppRouter() {
  const { user, loading } = useAuth();

  if (loading) {
    return <LoadingScreen />;
  }

  return (
    <Routes>
      {/* 👇 Wall route - فقط برای کاربران لاگین شده (بدون محدودیت نقش) */}
      <Route
        path="/wall"
        element={user ? <HomeComponent /> : <Navigate to="/login" replace />}
      />
      <Route
        path="/player-wall"
        element={
          user ? <PlayerWallComponent /> : <Navigate to="/login" replace />
        }
      />
      {/* اگر کاربر لاگین نیست */}
      {!user && (
        <>
          <Route path="/login" element={<Login />} />
          {/* Default for guests */}
          <Route path="*" element={<Navigate to="/login" replace />} />
        </>
      )}

      {/* اگر کاربر لاگین هست */}
      {user && (
        <>
          <Route
            path="/login"
            element={
              user.role.name === "customer" ? (
                <Navigate to="/dashboard/customer/Home" replace />
              ) : user.role.name === "support" ||
                user.role.name === "operator" ? (
                <Navigate to="/support" replace />
              ) : (
                <Navigate to="/" replace />
              )
            }
          />

          {/* صفحه support - برای نقش support و operator */}
          <Route
            path="/support"
            element={
              <ProtectedRoute allowedRoles={["support", "operator"]}>
                <SupportDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/accounts"
            element={
              user ? <AccountsComponent /> : <Navigate to="/login" replace />
            }
          />
          {/* Dashboard customer - فقط برای نقش customer */}
          <Route
            path="/dashboard/customer/*"
            element={
              <ProtectedRoute allowedRoles={["customer"]}>
                <CustomerDashboard />
              </ProtectedRoute>
            }
          />

          {/* Redirect default */}
          <Route
            path="*"
            element={
              user.role.name === "customer" ? (
                <Navigate to="/dashboard/customer/Home" replace />
              ) : user.role.name === "support" ||
                user.role.name === "operator" ? (
                <Navigate to="/support" replace />
              ) : (
                <Navigate to="/" replace />
              )
            }
          />
        </>
      )}
    </Routes>
  );
}

export default AppRouter;
